import React, {ReactNode} from 'react';

interface LinkProps {
    className?: string,
    children: ReactNode,
    href: string,
    opensInNewWindow?: boolean,
    onClick?: (any?) => any,
    includeRel?: boolean,
    underline?: boolean,
    linkRef?: React.Ref<HTMLAnchorElement>,
}

function Link(props: LinkProps) {
    const {
        children,
        href,
        opensInNewWindow = true,
        className = "gb--emphasize gb--emphasize-info",
        onClick,
        includeRel = true,
        underline = false,
        linkRef = undefined
    } = props

    return (
        <a
            onClick={onClick}
            className={className}
            href={href}
            target={opensInNewWindow ? "_blank" : "_self"}
            rel={includeRel ? "noreferrer" : undefined}
            style={underline ? {textDecoration: 'underline'} : {}}
            ref={linkRef}
        >
            {children}
        </a>
    );
}

export default Link;